import { createClient } from '@wix/sdk';
import { site } from '@wix/site';
import { STORES_APP_DEF_ID } from '../flow-api-adapter/consts';

type GlobalWixContext = {
  client?: unknown;
};

const isWixSdkClient = (client: unknown): boolean => {
  if (!client || typeof client !== 'object') {
    return false;
  }

  return (
    typeof (client as { use?: unknown }).use === 'function' &&
    typeof (client as { fetchWithAuth?: unknown }).fetchWithAuth === 'function'
  );
};

declare global {
  // eslint-disable-next-line no-var
  var __wix_context__: GlobalWixContext | undefined;
}

const createInstanceAuth = (instance?: string) =>
  instance
    ? {
        getAuthHeaders: async () => ({
          headers: {
            Authorization: instance,
          },
        }),
      }
    : undefined;

export const enableWixSdkContext = (isSSR: boolean, instance?: string) => {
  if (isSSR || typeof globalThis.window === 'undefined') {
    return;
  }

  if (isWixSdkClient(globalThis.__wix_context__?.client)) {
    return;
  }

  const wixClient = createClient({
    auth: createInstanceAuth(instance),
    host: site.host({ applicationId: STORES_APP_DEF_ID }),
  });

  wixClient.enableContext('global');
};
